module.exports = __webpack_public_path__ + "assets/img/financing-hero.0a3c2066.jpg";